// This file holds all possible default configuration
export default {
  env: undefined,
  kibanaApi: 'https://api-support-test.xfinity.com/logger/',
};
